module.exports = __webpack_public_path__ + "media/images/countrysquared/ci-f0acd74e8d2087c47d2dcdbe3cbd5c22.svg";